import { AmortizationTypeProvider } from "domain/AmortizationType";
import { CategoriesProvider } from "domain/Category";
import { CompaniesProvider } from "domain/Company";
import { SmallInventoryValueProvider } from "domain/SmallInventoryValue";

export const SettingsPageProvider = ({ children }) => (
  <CategoriesProvider>
    <CompaniesProvider>
      <SmallInventoryValueProvider>
        <AmortizationTypeProvider>{children}</AmortizationTypeProvider>
      </SmallInventoryValueProvider>
    </CompaniesProvider>
  </CategoriesProvider>
);
